/**
 * RFC 9457 problem+json — API_CONTRACT.md §8.
 *
 * The backend publishes its catalogue at `GET /v1/errors` and guarantees a
 * machine-readable `code` on every failure, so a client branches on `code` and
 * never parses prose. The catalogue itself is NOT duplicated here: `retryable`
 * arrives on the response, and `@erm/contracts` carries the canonical list.
 */
import { isErrorCode } from '@erm/contracts';
export class ApiError extends Error {
    code;
    title;
    detail;
    status;
    retryable;
    errors;
    meta;
    correlationId;
    constructor(status, problem) {
        const title = problem.title ?? 'Something went wrong';
        super(problem.detail ?? title);
        this.name = 'ApiError';
        this.status = status;
        this.code = problem.code ?? 'server.internal_error';
        this.title = title;
        this.detail = problem.detail ?? '';
        this.retryable = problem.retryable ?? false;
        this.errors = problem.errors ?? [];
        this.meta = problem.meta ?? {};
        this.correlationId = problem.correlation_id;
    }
    /** True when the code is one the backend actually publishes. */
    get isKnown() {
        return isErrorCode(this.code);
    }
    /**
     * §4.4 — a caller who is not a party to a resource receives 404, never 403.
     * The UI must therefore render "not found" and "not yours" identically, and
     * never distinguish them, or it re-introduces the leak the API closed.
     */
    get isNotFoundOrForbidden() {
        return this.status === 404;
    }
    /** Field errors keyed by field, for form binding. */
    fieldErrors() {
        return Object.fromEntries(this.errors.map((e) => [e.field, e.message]));
    }
}
export function isApiError(value) {
    return value instanceof ApiError;
}
//# sourceMappingURL=errors.js.map